var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ai-widget-segment',{attrs:{"label":_vm.s__('WorkItemDecisionLog|Decision log'),"data-testid":"decision-log-inline-row"}},[_c('span',{staticClass:"gl-text-subtle",attrs:{"data-testid":"decision-log-status"}},[_vm._v("\n    "+_vm._s(_vm.s__('WorkItemDecisionLog|No decisions yet'))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }